import { first, partition, some, sum } from "lodash-es";

export function getCountableAndNonCountablePersons(interviewHousehold, magiHousehold) {
    const [countable, nonCountable] = partition(interviewHousehold, x => {
        const doesExistInMagiHousehold = some(magiHousehold.members, y => y.personId === x.personId);
        return doesExistInMagiHousehold;
    });

    return { countable, nonCountable };
}

export function getTotalCountableAndExcludedIncome(interview, countableInterviewPersons, magiHousehold) {
    const interviewIncome = interview?.personInfoScreening
        .filter(x => x.incomeInfo != null)
        .map(x => x.incomeInfo)
        .filter(x => x.doesReceiveIncome === true && x.incomes != null && x.incomes.length > 0);

    return countableInterviewPersons.map((person, i) => {
        const magiPerson = magiHousehold.members.filter(x => x.personId === person.personId)[0];
        const totalIncomeInfo = interviewIncome.filter(x => x.personId === person.personId)[0];
        const [allowable, excluded] = partition(totalIncomeInfo?.incomes, interviewIncome => {
            return some(
                magiPerson?.financials?.incomes,
                magiIncome =>
                    magiIncome.incomeType.name === interviewIncome.incomeType &&
                    magiIncome.amount === interviewIncome.amount &&
                    /* Employer name is optional and can be null. The server returns undefined for magiIncome.employerName.
                       When using === null and undefined are not equal. Using == solves the issues
                    */
                    magiIncome.employerName == interviewIncome.nameOfEmployer
            );
        });

        let totalAllowable = magiPerson?.financials?.totalMonthlyIncome;

        if (totalAllowable == null) {
            totalAllowable = allowable;
        }

        let totalExcluded = sum(excluded.map(x => x.monthlyAmount));

        /*
            sum returns a string if an input string is passed and it only contains 1 element
            If there are 2 elements, it will cast it to a number
         */
        if (typeof totalExcluded === "string") {
            totalExcluded = parseFloat(totalExcluded);
        }

        return {
            personId: person.personId,
            totalAllowable: totalAllowable,
            totalExcluded: totalExcluded,
        };
    });
}

export function getTotalMonthlyIncomeForMember(personId, interview) {
    const person = first(interview.personInfoScreening.filter(x => x.personId === personId));
    if (person == null) {
        return 0;
    }

    const income = person.incomeInfo;

    if (income == null || income.doesReceiveIncome === false || income.incomes == null || income.incomes.length === 0) {
        return 0;
    }

    return sum(income.incomes.map(x => x.monthlyAmount));
}

export function getMagiMonthlyIncomeForMember(personId, magiHousehold) {
    const person = first(magiHousehold.members.filter(x => x.personId === personId));
    if (person == null) {
        return 0;
    }

    const totalMagiIncome = person.financials?.totalMonthlyIncome;
    if (totalMagiIncome == null) {
        return 0;
    }

    return totalMagiIncome;
}

export function calculateTotalAllowableIncome(magiHousehold) {
    const totalIncome = magiHousehold.financials?.totalMonthlyIncome;
    if (totalIncome == null) {
        return 0;
    }

    return totalIncome;
}

export function createHouseholdMembersFromInterview(interview) {
    const patient = { ...interview.entry.patient };
    patient.relationshipToPatient = "Patient";

    const householdMembers = [patient, ...interview.householdMembers];
    if (interview.entry.isResponsiblePartyDifferentFromPatient) {
        if (interview.entry.responsibleParty) {
            householdMembers.push(interview.entry.responsibleParty);
        }
    }

    return householdMembers;
}

export function getApplicableHouseholds(households) {
    return households
        .filter(x => x.householdType.name !== "Interview")
        .sort((a, b) => {
            if (a.householdType.name === "MAGI") {
                return -1;
            }

            if (b.householdType.name === "MAGI") {
                return 1;
            }

            return a.householdType.name < b.householdType.name;
        });
}
